/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

import Header from "../../components/includes/Header";
import HeaderTitle from "../../components/includes/HeaderTitle";
import Footer from "../../components/includes/Footer";
import FlyCalling from "../../components/includes/FlyCalling";

import SetupCurrentMonth from "../../components/deliverys/SetupCurrentMonth";
import SetupCalendar from "../../components/deliverys/SetupCalendar";

import {
  LoginAfterCheckLogin,
  ChangeSearchingDateFormat,
  addThousandPoint,
  FirstDayForMonth,
  ChangeDateFormat,
  isNull,
} from "../../components/common/Common";

import "../../css/style.css";

//배차목록호출
const DeliveryHistory = () => {
  LoginAfterCheckLogin(1); //로그인 상태 점검

  const mem_idx = localStorage.getItem("mem_idx");
  //검색일자
  const [varCurrentDate, setCurrentDate] = useState(null);
  const [varCurrentMonth, setCurrentMonth] = useState(null);
  //배차목록
  const [varMonthDeliveryRecord, setMonthDeliveryRecord] = useState({});
  //검색일자
  const [varSelectDateDelivery, setSelectDateDelivery] = useState([]);

  const [noteData, setNoteData] = useState("");

  //월별 운행내역
  const GetDeliveryList = async () => {
    const cdate = ChangeSearchingDateFormat(varCurrentDate, "-");
    const sendData = { mem_idx: mem_idx, dc_riding_date: cdate };
    console.log(sendData);
    await axios
      .post(
        `${process.env.REACT_APP_HOST}/_get_delivery_list_bymonth`,
        sendData
      )
      .then((res) => {
        const datas = res.data;
        console.log(datas);
        if (datas.retvalue === 1) {
          setMonthDeliveryRecord({
            mCount: datas.mcount,
            mIncome: datas.mincome,
            mVolume: datas.mvolume,
            mprice: datas.mprice,
          });
          setNoteData(datas.settlement_note);
        }
      });
  };
  //선택일자별 운행내역
  const GetDailyDeliveryList = async () => {
    const cdate = ChangeSearchingDateFormat(varCurrentDate, "-");
    const sendData = { mem_idx: mem_idx, dc_riding_date: cdate };
    console.log(sendData);
    await axios
      .post(`${process.env.REACT_APP_HOST}/_get_delivery_list_byday`, sendData)
      .then((res) => {
        const datas = res.data;
        console.log(datas);
        let bexist = false;
        if (datas.retvalue === 1) {
          if (datas.results?.length > 0) {
            bexist = true;
            setSelectDateDelivery(datas.results);
          }
        }
        if (!bexist) setSelectDateDelivery([]);
      });
  };

  //검색날짜가 변경시
  useEffect(() => {
    let nowDate = new Date();
    if (!isNull(localStorage.getItem("setHistoryDate")))
      nowDate = new Date(localStorage.getItem("setHistoryDate"));
    setCurrentMonth(FirstDayForMonth(nowDate));
    setCurrentDate(nowDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //검색날짜가 변경시
  useEffect(() => {
    GetDeliveryList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varCurrentMonth]);

  //검색날짜가 변경시
  useEffect(() => {
    GetDailyDeliveryList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varCurrentDate]);

  //월변경
  const onChangeCurrentMonthHandler = (e, imonth) => {
    e.preventDefault();
    const smonth = varCurrentDate.getMonth();
    const nDate = new Date(varCurrentDate.setMonth(smonth + imonth));
    setCurrentDate(nDate);
    setCurrentMonth(FirstDayForMonth(nDate));
    //날짜를 메모리에 별도 저장
    const setDate = ChangeDateFormat(nDate);
    localStorage.setItem("setHistoryDate", setDate);
  };
  //날짜변경
  /* const onChangeCurrentDateHandler = (e,idays) => {
    e.preventDefault();
    const sdate = varCurrentDate.getDate();
    const nDate = new Date(varCurrentDate.setDate(sdate + idays));
    //console.log(idays,nDate);
    setCurrentDate(nDate);
    //console.log(varCurrentMonth,nDate);
    if(varCurrentMonth.getMonth() !== nDate.getMonth()) {
      setCurrentMonth(FirstDayForMonth(nDate));
    }
  } */
  //날짜선택
  const onSelectDateHandler = (e, sdate) => {
    const cdate = varCurrentDate;
    const nDate = new Date(cdate.getFullYear(), cdate.getMonth(), sdate);
    setCurrentDate(nDate);
    //날짜를 메모리에 별도 저장
    const setDate = ChangeDateFormat(nDate);
    localStorage.setItem("setHistoryDate", setDate);
  };

  return (
    <div className="vh-container">
      <Header varGoToMain={true} />
      <div className="vh-content">
        <HeaderTitle varPageTitle={"운행 일지"} />
        <div className="vh-content-body">
          {varCurrentDate === null ? null : (
            <SetupCurrentMonth
              varCurrentDate={varCurrentDate}
              onChangeCurrentMonthHandler={onChangeCurrentMonthHandler}
            />
          )}
          <div className="driving-dashboard mb20">
            <div className="dashboard-title mb10">이번 달 운행 대시보드</div>
            <div className="dashboard-list mb10">
              <div className="dashboard-card">
                <div className="dashboard-top">
                  <span className="num">{varMonthDeliveryRecord.mCount}</span>
                  <span className="unit">건</span>
                </div>
                <div className="dashboard-bot">등록 건수</div>
              </div>
              <div className="dashboard-card">
                <div className="dashboard-top">
                  <span className="num">
                    {addThousandPoint(varMonthDeliveryRecord.mprice)}
                  </span>
                  <span className="unit">원</span>
                </div>
                <div className="dashboard-bot">실 운행가</div>
              </div>
              <div className="dashboard-card">
                <div className="dashboard-top">
                  <span className="num">
                    {addThousandPoint(varMonthDeliveryRecord.mIncome)}
                  </span>
                  <span className="unit">원</span>
                </div>
                <div className="dashboard-bot">기사님 지급원가</div>
              </div>
              <div className="dashboard-card">
                <div className="dashboard-top">
                  <span className="num">
                    {addThousandPoint(varMonthDeliveryRecord.mVolume)}
                  </span>
                  <span className="unit">Km</span>
                </div>
                <div className="dashboard-bot">운행량</div>
              </div>
            </div>
            <div className="dashboard-title mb10">이번 달 정산 메모</div>
            <div className="dashboard-card">
              <div>
                {noteData ? (
                  noteData
                    .split("\n")
                    .map((line, index) => <p key={index}>{line}</p>)
                ) : (
                  <p>정산 메모가 없습니다.</p>
                )}
              </div>
            </div>
          </div>
          {/* 달력 */}
          {varCurrentMonth === null ? null : (
            <SetupCalendar
              varCurrentMonth={varCurrentMonth}
              varCurrentDate={varCurrentDate}
              onSelectDateHandler={onSelectDateHandler}
            />
          )}
          {/* 일지 */}
          <div
            className="driving-journal-wrap bd-t mt-auto"
            style={{ marginBottom: "84px" }}
          >
            <div className="driving-journal-head">
              <div className="th">상차지</div>
              <div className="th">하차지</div>
              <div className="th">인수증</div>
            </div>
            <ul className="driving-journal-body">
              {varSelectDateDelivery?.length === 0 ? (
                <li>
                  <div>운행내역이 없습니다.</div>
                </li>
              ) : (
                varSelectDateDelivery.map((delivery, i) => (
                  <Link
                    key={"delivery_" + i}
                    to={`/DeliveryDetail/${delivery.dc_idx}`}
                  >
                    <li>
                      <div className="td">{delivery.dc_riding_address}</div>
                      <div className="td">{delivery.dc_quit_address}</div>
                      <div className="td">
                        {delivery.dc_receipt_image === 1 ? (
                          <span className="blue">등록</span>
                        ) : delivery.dc_receipt_image === 0 ? (
                          <span className="blue">미등록</span>
                        ) : (
                          <span>없음</span>
                        )}
                      </div>
                    </li>
                  </Link>
                ))
              )}
            </ul>
          </div>
        </div>
        <Footer varActiveMode={2} />
        <FlyCalling />
      </div>
    </div>
  );
};
export default DeliveryHistory;
